import { useCallback } from 'react';
import { useQuery } from 'react-query';
import { Permission } from '../@types/Roles';

import { useAxios } from '../context/AxiosContext';

export function usePermissionsList() {
  const { authAxios } = useAxios();

  const fetchPermissions = useCallback(async (): Promise<Permission[]> => {
    const response = await authAxios.get<any>('/roles/permissions');
    return response.data;
  }, [authAxios]);

  return useQuery('role-features', fetchPermissions, {
    refetchOnWindowFocus: false,
    suspense: true
  });
}
